import { ColumnFactory } from '../excel';
export const UnileverColumns = new ColumnFactory()
  .addColumnsFromPredefined('title')
  .addColumnsFromPredefined('status')
  .addColumnsFromPredefined('succeeded')
  .addColumnsFromPredefined('driver')
  .addColumnsFromPredefined('vehicle')
  .addColumnsFromPredefined('totalDuration')
  .addColumnsFromPredefined('totalDistance')
  .addColumnsFromPredefined('beginDate')
  .addColumnsFromPredefined('endDate')
  .getColumns();
